"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageBarTemplate = require("../Checkboxes/ImageBars/ImageBarTemplate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledCheck = _styledComponents.default.span.withConfig({
  displayName: "StyledCheck"
})(["height:16px;min-width:16px;border-radius:10px;border:", ";box-sizing:border-box;border-color:", ";"], function (_ref) {
  var checked = _ref.checked;
  return checked ? '5px solid' : '1.2px solid';
}, function (_ref2) {
  var checked = _ref2.checked,
      theme = _ref2.theme;
  return checked ? theme.brand.secondary : theme.ui.outline;
});

var FlightData = _styledComponents.default.div.withConfig({
  displayName: "FlightData"
})(["display:flex;flex-direction:column;border-right:", ";padding-right:", ";margin-right:7%;.label{font-size:1.4rem;line-height:120%;color:", ";}.data{font-size:1.6rem;line-height:120%;color:#505050;font-weight:500;}"], function (_ref3) {
  var border = _ref3.border,
      theme = _ref3.theme;
  return border ? "1px solid ".concat(theme.ui.outline) : null;
}, function (_ref4) {
  var border = _ref4.border;
  return border ? '1.7vw' : null;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.labels.defaultText;
});

var StyledContainer = (0, _styledComponents.default)(_ImageBarTemplate.Container).withConfig({
  displayName: "StyledContainer"
})(["width:52vw;justify-content:space-around;padding:0 2vw;box-shadow:0px 2px 5px rgba(0,0,0,0.05);svg{margin:0;}", ";", " > span{color:", ";}"], function (_ref6) {
  var checked = _ref6.checked,
      theme = _ref6.theme;
  return checked ? (0, _styledComponents.css)(["background-color:", ";border-color:", ";", "{border-right-color:", ";.label{color:", ";}.data{color:", ";}}svg{fill:", ";stroke:", ";}"], theme.brand.lightest, theme.brand.secondary, FlightData, theme.brand.secondary, theme.brand.secondary, theme.brand.primary, theme.brand.secondary, theme.brand.secondary) : null;
}, FlightData, function (_ref7) {
  var disabled = _ref7.disabled,
      theme = _ref7.theme;
  return disabled ? theme.ui.outline : null;
});

var StyledFlightData = function StyledFlightData(_ref8) {
  var border = _ref8.border,
      label = _ref8.label,
      data = _ref8.data,
      children = _ref8.children;
  return /*#__PURE__*/_react.default.createElement(FlightData, {
    border: border
  }, label && data && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement("span", {
    className: "data"
  }, data)), children);
};

StyledFlightData.propTypes = {
  border: _propTypes.default.bool,
  label: _propTypes.default.string,
  data: _propTypes.default.string,
  children: _propTypes.default.node
};
StyledFlightData.defaultProps = {
  border: false
};
var FlightSelectBar = /*#__PURE__*/(0, _react.forwardRef)(function (_ref9, ref) {
  var checked = _ref9.checked,
      disabled = _ref9.disabled,
      handleChange = _ref9.handleChange,
      value = _ref9.value,
      children = _ref9.children,
      name = _ref9.name,
      otherProps = _objectWithoutProperties(_ref9, ["checked", "disabled", "handleChange", "value", "children", "name"]);

  var onChange = function onChange(e) {
    e.persist();
    handleChange({
      name: e.target.name,
      value: e.target.value
    });
  };

  return /*#__PURE__*/_react.default.createElement(StyledContainer, _extends({
    checked: checked,
    disabled: disabled
  }, otherProps), /*#__PURE__*/_react.default.createElement(_ImageBarTemplate.StyledInput, {
    ref: ref,
    type: "radio",
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    value: value,
    name: name
  }), children, /*#__PURE__*/_react.default.createElement(StyledCheck, {
    checked: checked
  }));
});
FlightSelectBar.displayName = 'RadioOption';
FlightSelectBar.FlightData = StyledFlightData;
FlightSelectBar.FlightData.displayName = 'FlightSelectBar.FlightData';
FlightSelectBar.propTypes = {
  checked: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool,
  name: _propTypes.default.string,
  handleChange: _propTypes.default.func,
  value: _propTypes.default.string,
  icon: _propTypes.default.elementType,
  children: _propTypes.default.node
};
FlightSelectBar.defaultProps = {
  checked: false,
  value: '',
  name: ''
};
var _default = FlightSelectBar;
exports.default = _default;